import { render, staticRenderFns } from "./FlashLinkLayout.vue?vue&type=template&id=5b47f75f"
import script from "./FlashLinkLayout.vue?vue&type=script&lang=ts"
export * from "./FlashLinkLayout.vue?vue&type=script&lang=ts"
import style0 from "./FlashLinkLayout.vue?vue&type=style&index=0&id=5b47f75f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports